import React, { Component } from 'react';
import { PageContainer, TextBlock, Responses, BottomButtons, Button } from '../components/styledComponents';
import Response from '../components/Response';

const audios = [
  {
    name: 'Pasi',
    audio: 'audio/pasi.m4a',
    image: 'images/pasi.jpg',
  },
  {
    name: 'Toni',
    audio: 'audio/toni.m4a',
    image: 'images/toni.jpg',
  },
  {
    name: 'Miika',
    audio: 'audio/miika.m4a',
    image: 'images/miika.jpg',
  },
  {
    name: 'Chris',
    audio: 'audio/chris.m4a',
    image: 'images/chris.jpg',
  }
];

class CommunityAnswers extends Component {
  state = {
    playing: null,
  };
  play = name => {
    if (this.audio) {
      this.stop();
      this.audio = null;
    }
    const audioFile = audios.find(audio => audio.name === name).audio;
    this.audio = new Audio(audioFile);
    this.audio.play();
    this.audio.onended = () => {
      if (this.state.playing === name) {
        this.stop();
      }
    };
    this.setState({ playing: name });
  };
  stop = () => {
    this.audio.pause();
    this.audio.currentTime = 0;
    this.setState({ playing: null });
  };
  togglePlayback = name => {
    if (this.audio && this.state.playing === name) {
      this.stop();
    } else {
      this.play(name);
    }
  };

  render() {
    return (
      <PageContainer style={{ paddingTop: '20px' }}>
        <TextBlock style={{ paddingBottom: '10px' }}>
          <h3>Great job!</h3>
          <p>You just made your first journal entry</p>
          <p>Some people like to share their thoughts and inspire others</p>
          <p>Feel free to listen to some community entries</p>
        </TextBlock>
        <Responses>
          {audios.map((audio, index) => (
            <Response
              key={index}
              img={audio.image}
              name={audio.name}
              onClick={this.togglePlayback}
              playing={this.state.playing === audio.name}
              status={'public'}
            />
          ))}
        </Responses>
        <BottomButtons>
        	<Button style={{ margin: '0 10px' }} onClick={() => this.props.onProceed()}>My DashBoard</Button>
        </BottomButtons>
      </PageContainer>
    );
  }
}

export default CommunityAnswers;
